// ── 공통 상수 — 색상 팔레트, 타입 설정, 초기값 ────────────────────────────────

// 색상 팔레트 — dark mode: CSS 변수 토큰 사용
export const C = {
  minus:   '#ef4444',  // 차감 (빨강) — 시맨틱 고정
  minusBg: '#fee2e2',
  plus:    '#10b981',  // 수입 (초록) — 시맨틱 고정
  plusBg:  '#d1fae5',
  accent:  '#6366f1',  // 인디고 강조 — 시맨틱 고정
  border:  'var(--border)',
  sub:     'var(--text-muted)',
  subDark: 'var(--text-sub)',
  main:    'var(--text)',
};

// 날짜순 뷰 타입별 뱃지 설정 (label, bg, color)
export const TYPE_CFG = {
  contract:   { label: '계약차감', bg: '#fee2e2', color: '#dc2626' },
  delivery:   { label: '택배비',   bg: '#fef3c7', color: '#b45309' },
  promo:      { label: '홍보물',   bg: '#fef3c7', color: '#b45309' },
  promo_pending: { label: '홍보물 예정', bg: '#fffbeb', color: '#b45309' },
  card:       { label: '카드',     bg: '#dbeafe', color: '#1d4ed8' },
  phone:      { label: '전화',     bg: '#ede9fe', color: '#7c3aed' },
  deposit:    { label: '입금',     bg: '#d1fae5', color: '#059669' },
  settlement: { label: '정산지급', bg: '#ccfbf1', color: '#0d9488' }, // 민트 (돈 받음)
  consultant_charge: { label: '1:1급여', bg: '#fee2e2', color: '#dc2626' },
  others:     { label: '기타',    bg: '#fffbeb', color: '#b45309' }, // 앰버 (기타 수입)
};

// 미연결 수입 초기값 (모듈 상수 — 렌더마다 새 객체 생성 방지)
export const EMPTY_UNM_REV = {
  phones:         [], phoneTotal:     0,
  deposits:       [], depositTotal:   0,
  cards:          [], cardTotal:      0,
  cardUploads:    [], cardUploadTotal: 0,
  consultantCharges: [], consultantChargesTotal: 0,
  plusTotal: 0,
};
